export default __webpack_public_path__ + "static/media/cross.4f605738.svg";